import classNames from 'classnames'
import { useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import Logo from '../../Logo'
import LogoutButton from '../auth/LogoutButton'
import { useAuth0 } from '@auth0/auth0-react'
import RegisterButton from '../auth/RegisterButton'
import MyModal from '../common/MyModal'
import useModal from '../../hooks/useModal'
import ProfileDropdownMenu from '../common/ProfileDropdownMenu'
import FeatherIcon from 'feather-icons-react'
import { Dropdown, Nav, Navbar } from 'react-bootstrap'

// reusable component for navigation items
const NavItem = ({ label, url, isLast }: { label: string; url: string; isLast?: boolean }) => {
  return (
    <Nav.Item
      as="li"
      className={classNames({
        'border-bottom border-bottom-lg-0 d-flex justify-content-center': !isLast,
      })}
    >
      <Nav.Link href={url} className="lh-1 py-0 fs-9 fw-medium py-3 d-flex justify-content-center">
        {label}
      </Nav.Link>
    </Nav.Item>
  )
}

const LandingNavBar = ({ className }: { className?: string }) => {
  const { showModal, handleCloseModal } = useModal() // custom hook for modal use
  const { isAuthenticated, isLoading } = useAuth0()
  const containerRef = useRef<HTMLDivElement | null>(null)
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // Smooth scrolling effect
    })
  }
  // if (isLoading) {
  //   return null // Or return a loading indicator if preferred. added this to prevent the topbar from rendering before the user is authenticated, trying to fix bug where login and reister button still show up on homeoage when user is logged in
  // }

  useEffect(() => {
    const toggleShadowClass = () => {
      if (window.scrollY > 300) {
        containerRef.current?.classList.add('navbar-shadow')
      } else {
        containerRef.current?.classList.remove('navbar-shadow')
      }
    }

    document.addEventListener('scroll', () => toggleShadowClass())

    return () => document.removeEventListener('scroll', toggleShadowClass)
  }, [])
  if (isLoading) {
    return null // Or return a loading indicator if preferred. added this to prevent the topbar from rendering before the user is authenticated, trying to fix bug where login and reister button still show up on homeoage when user is logged in
  }
  return (
    <>
      <div
        className={classNames(className, 'bg-white sticky-top landing-navbar ')}
        ref={containerRef}
      >
        <Navbar className="px-3 px-lg-7 px-xxl-2 container-small" expand="lg">
          <Navbar.Brand as={Link} to="/">
            <div onClick={scrollToTop} style={{ cursor: 'pointer' }}>
              <Logo /> {/* Logo will be clickable */}
            </div>
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse>
            <Nav
              // onClick={handleShowModal} // under construction modal
              className="me-auto mb-2 mb-lg-0"
              as="ul"
            >
              <NavItem label="Inicio" url="/home" />
              <NavItem label="Busca Proveedores" isLast url="/home/searchpage" />
            </Nav>

            <div className="gap-3 align-items-center justify-content-center">
              <div className="d-flex">
                {!isAuthenticated && (
                  <>

                    <Link to="" className="">
                      <RegisterButton />
                    </Link>
                  </>
                )}
              </div>
              {isAuthenticated && ( // logout, only appears when user is authenticated
                <Link to="#!" className="btn btn-link p-0 text-900 order-lg-0">
                  <LogoutButton />
                </Link>
              )}
              {isAuthenticated && ( // logout, only appears when user is authenticated
                <Nav.Item as="li" style={{ listStyle: 'none' }}>
                  <Dropdown autoClose="outside">
                    <Dropdown.Toggle
                      as={Link}
                      to="#!"
                      className="dropdown-caret-none nav-link lh-1"
                      variant=""
                    >
                      <FeatherIcon icon="user" size={20} />
                    </Dropdown.Toggle>

                    <ProfileDropdownMenu className="mt-2" />
                  </Dropdown>
                </Nav.Item>
              )}
            </div>
          </Navbar.Collapse>
        </Navbar>
        <MyModal show={showModal} onHide={handleCloseModal} />
      </div>
    </>
  )
}

export default LandingNavBar
